import { defineStore } from 'pinia';
import { ref } from 'vue';
import { api, ApiCallError } from '@/api/client';
import type { Payment, PaymentsPage } from '@/api/types';

export const usePaymentsStore = defineStore('payments', () => {
  const items = ref<Payment[]>([]);
  const cursor = ref<string | null>(null);
  const exhausted = ref(false);
  const loading = ref(false);
  const error = ref<string | null>(null);

  async function loadFirst() {
    items.value = [];
    cursor.value = null;
    exhausted.value = false;
    await loadMore();
  }

  async function loadMore() {
    if (loading.value || exhausted.value) return;
    loading.value = true;
    error.value = null;
    try {
      const params = new URLSearchParams({ limit: '20' });
      if (cursor.value) params.set('cursor', cursor.value);
      const page = await api.get<PaymentsPage>(`/me/payments?${params}`);
      items.value.push(...page.items);
      cursor.value = page.next_cursor;
      exhausted.value = page.next_cursor === null;
    } catch (e) {
      error.value = e instanceof ApiCallError ? e.message : 'Не удалось загрузить платежи';
    } finally {
      loading.value = false;
    }
  }

  return { items, cursor, exhausted, loading, error, loadFirst, loadMore };
});
